import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import AccountBox from "@material-ui/icons/AccountBox";
import React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { LinkButton } from "../components/link-button";
import { SearchPage } from "../components/search-page";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { UserLevel } from "../model/autogen/UserLevel";
import { UserModel } from "../model/autogen/UserModel";
import { UsersRequestFactory } from "../model/autogen/UsersController";
import { RoutePaths, UserEditRoute, UserSearchRoute } from "../route-paths";
import { WithDefaultStyles, withDefaultStyles } from "../utils/createStyles";
import Public from "@material-ui/icons/Public";
import Button from "@material-ui/core/Button/Button";
import { withSnackbar, ISnackbarContextProps } from "../components/with-snackbar";

export const UserSearchResultItem = (props: { result: UserModel }) => <ListItem divider={true} button={true}
    component={(listProps => <Link to={UserEditRoute(props.result.userID)} className={listProps.className}>{listProps.children}</Link>)}>
    <ListItemIcon>
        {props.result.level == UserLevel.External ? <Public /> : <AccountBox />}
    </ListItemIcon>
    <ListItemText primary={`${props.result.firstName} ${props.result.lastName}`} secondary={props.result.email} />
</ListItem>;

interface IUserRouteParams {
    query: string
}

type UserSearchContainerProps = RouteComponentProps<IUserRouteParams> & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles;

class UserSearchContainer extends React.Component<UserSearchContainerProps, any> {
    constructor(props: UserSearchContainerProps) {
        super(props);
        this.state = {
            query: this.props.match.params.query,
            loading: false
        }
    }
    public async componentDidMount() {
        const [term, items] = await this.performSearch(this.state.query);
        this.setState({
            items,
            query: term
        });
    }
    public async componentWillReceiveProps(nextProps: RouteComponentProps<IUserRouteParams>) {
        if (this.props.match.params.query !== nextProps.match.params.query) {
            const [term, items] = await this.performSearch(nextProps.match.params.query);
            this.setState({
                items,
                query: term
            });
        }
    }
    private async performSearch(term: string | undefined): Promise<[string | undefined, (UserModel[] | undefined)]> {
        this.setState({ loading: true });
        const matches = await this.props.callApi((fetcher) => UsersRequestFactory.find(fetcher, term || ""));
        this.setState({ loading: false });
        return [term, matches];
    }
    private onSearch = (term: string) => {
        this.props.history.replace({ pathname: UserSearchRoute(term || '') });
    }
    private onFindAllUsers = async (e: any) => {
        try {
            this.setState({ loading: true, items: undefined, query: undefined });
            const matches = await this.props.callApi((fetcher) => UsersRequestFactory.findAll(fetcher));
            this.setState({ loading: false, items: matches, query: undefined });
        } catch (e) {
            this.props.showSnackbarMessage("Error performing search");
            this.setState({ loading: false, items: undefined, query: undefined });
        }
    }
    private renderSearchResultItem = (item: any, index: number) => {
        return <UserSearchResultItem key={index} result={item} />;
    }
    public render() {
        return <>
            <SearchPage
                items={this.state.items}
                query={this.props.match.params.query}
                searchPlaceholder="Search Users"
                onSearch={this.onSearch}
                renderSearchResultItem={this.renderSearchResultItem}
                loading={this.state.loading}
            />
            <LinkButton className={this.props.classes.input} variant="contained" to={RoutePaths.UserCreate}>Create User</LinkButton>
            <Button className={this.props.classes.input} variant="contained" disabled={this.state.loading} onClick={this.onFindAllUsers}>Show All Users</Button>
        </>;
    }
}

export const UserSearchPage = withSnackbar(withDefaultStyles(withAuthContext(UserSearchContainer, UserLevel.Admin)));


// WEBPACK FOOTER //
// ./src/pages/user-search.tsx